import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MgsActiveState } from './mgs-active.state';
import { MngIconComponent } from '@mng/mng-icon';
import { MngFrameComponent } from '@mng/mng-frame';
import { MngActionDef } from '@mng/mng-inputs';
import { DIENSTLEISTUNG_PATH } from './mgs-path-defs';
import { MgsRoutingService } from './mgs-routing.service';

const dienstleistungPath = `${DIENSTLEISTUNG_PATH}/`;

@Component({
  selector: 'mgs-nav-container',
  imports: [MngIconComponent],
  templateUrl: './mgs-nav-container.component.html',
  styleUrl: './mgs-nav-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MgsNavContainerComponent {
  readonly activeState = inject(MgsActiveState);
  frame = input.required<MngFrameComponent>();
  readonly activeRouteTitle = inject(MgsRoutingService).routeTitle;
  readonly activeRouteInfo = inject(MgsRoutingService).routeInfo;

  isActive(actionDef: MngActionDef): boolean {
    // Spezialbehandlung für den Pfad für die Dienstleistungsbearbeitung
    if (this.activeRouteInfo()?.url?.includes(dienstleistungPath)) {
      if (actionDef.target?.length === 1) {
        const target = actionDef.target[0];
        if (target.includes(dienstleistungPath)) {
          return true;
        }
      }
    }

    // Ansonsten wird einfach über der "title" verglichen da der der title der route gleich
    // dem title in der actionDef ist
    return this.activeRouteTitle() === actionDef.getTitle();
  }
}
